// Packages
import React from "react"
import { Outlet } from "react-router-dom"

const Guest = () => {
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  )
}

export default Guest
